import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const ClearAdLink = new ReduxAsyncAction<'CLEAR_AD_LINK', any, Record<string, any>>('CLEAR_AD_LINK');

ClearAdLink.registerRequest(async () => {
  return {};
});

export const CLEAR_AD_LINK = ClearAdLink.actionNamespaceConstants;

export const clearAdLink = ClearAdLink.request;

export type ClearAdLinkResponseAction = Action<typeof CLEAR_AD_LINK.response> & {
  data: {};
};
